var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 48,
    viewBox: "0 0 160 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.074 48H5.92593C2.66667 48 0 45.3 0 42V6C0 2.7 2.66667 0 5.92593 0H154.074C157.333 0 160 2.7 160 6V42C160 45.3 157.333 48 154.074 48Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4122 11.9388C56.4122 12.9159 56.1183 13.6936 55.5293 14.2743C54.8609 14.9645 53.9886 15.3097 52.9172 15.3097C51.8909 15.3097 51.0175 14.9599 50.3004 14.2603C49.5822 13.5595 49.2231 12.692 49.2231 11.6566C49.2231 10.6201 49.5822 9.75258 50.3004 9.05299C51.0175 8.35224 51.8909 8.00244 52.9172 8.00244C53.4268 8.00244 53.9139 8.10038 54.3761 8.29627C54.8395 8.49215 55.2105 8.75217 55.4878 9.07748L54.8632 9.69312C54.3927 9.13927 53.7445 8.86294 52.916 8.86294C52.167 8.86294 51.5199 9.12178 50.9736 9.63948C50.4296 10.156 50.1559 10.8276 50.1559 11.6555C50.1559 12.4833 50.4284 13.1549 50.9748 13.6738C51.5211 14.1915 52.1682 14.4503 52.9172 14.4503C53.7113 14.4503 54.3738 14.1903 54.9035 13.6691C55.2472 13.3298 55.4463 12.8576 55.4997 12.2524H52.9172V11.4106H56.3624C56.3968 11.5937 56.4122 11.7697 56.4122 11.9388Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8757 9.01656H58.6379V11.2343H61.5581V12.0749H58.6379V14.2926H61.8757V15.1531H57.7241V8.15723H61.8757V9.01656Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7287 15.1531H64.8149V9.01656H62.8286V8.15723H67.715V9.01656H65.7287V15.1531Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 15.1531V8.15723H72.1637V15.1531H71.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.216 15.1531H75.3022V9.01656H73.3159V8.15723H78.2023V9.01656H76.216V15.1531Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4525 14.2497C86.7533 14.9574 85.8846 15.3095 84.8452 15.3095C83.8058 15.3095 82.9371 14.9563 82.2391 14.2497C81.5398 13.5431 81.1914 12.6779 81.1914 11.6554C81.1914 10.6328 81.5398 9.76763 82.2391 9.06104C82.9371 8.35329 83.8058 8 84.8452 8C85.8786 8 86.7462 8.35563 87.4478 9.06571C88.1494 9.77579 88.5002 10.6386 88.5002 11.6554C88.5002 12.6779 88.1506 13.5431 87.4525 14.2497ZM82.9134 13.6632C83.4396 14.1879 84.0832 14.449 84.8452 14.449C85.6072 14.449 86.252 14.1867 86.777 13.6632C87.3032 13.1385 87.5675 12.4692 87.5675 11.6554C87.5675 10.8415 87.3032 10.1711 86.777 9.64753C86.252 9.12284 85.6072 8.86166 84.8452 8.86166C84.0832 8.86166 83.4396 9.12401 82.9134 9.64753C82.3884 10.1722 82.1241 10.8415 82.1241 11.6554C82.1241 12.4692 82.3884 13.1397 82.9134 13.6632Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7822 15.1531V8.15723H90.8939L94.3498 13.5989H94.3889L94.3498 12.251V8.15723H95.2635V15.1531H94.3095L90.6936 9.4468H90.6545L90.6936 10.7947V15.1531H89.7822Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9662 25.3578C78.1788 25.3578 75.9068 27.4426 75.9068 30.3168C75.9068 33.1722 78.1788 35.2757 80.9662 35.2757C83.7537 35.2757 86.0256 33.1722 86.0256 30.3168C86.0256 27.4426 83.7537 25.3578 80.9662 25.3578ZM80.9662 33.3215C79.4386 33.3215 78.1207 32.0821 78.1207 30.3156C78.1207 28.5305 79.4386 27.3097 80.9662 27.3097C82.4939 27.3097 83.8106 28.5305 83.8106 30.3156C83.8106 32.0821 82.4939 33.3215 80.9662 33.3215ZM69.9278 25.3578C67.1403 25.3578 64.8684 27.4426 64.8684 30.3168C64.8684 33.1722 67.1403 35.2757 69.9278 35.2757C72.7152 35.2757 74.9872 33.1722 74.9872 30.3168C74.9884 27.4426 72.7164 25.3578 69.9278 25.3578ZM69.9278 33.3215C68.4001 33.3215 67.0834 32.0821 67.0834 30.3156C67.0834 28.5305 68.4013 27.3097 69.9278 27.3097C71.4554 27.3097 72.7721 28.5305 72.7721 30.3156C72.7733 32.0821 71.4554 33.3215 69.9278 33.3215ZM56.7988 26.8794V28.9829H61.9162C61.7633 30.1663 61.3628 31.0303 60.7512 31.632C60.007 32.3642 58.842 33.1722 56.7988 33.1722C53.6487 33.1722 51.1859 30.6735 51.1859 27.5744C51.1859 24.4752 53.6487 21.9765 56.7988 21.9765C58.4983 21.9765 59.7391 22.6341 60.6552 23.4794L62.1639 21.9951C60.8852 20.793 59.1857 19.873 56.7988 19.873C52.4837 19.873 48.856 23.329 48.856 27.5744C48.856 31.8197 52.4837 35.2757 56.7988 35.2757C59.1288 35.2757 60.8852 34.5248 62.2599 33.1151C63.6726 31.7253 64.1123 29.7711 64.1123 28.1935C64.1123 27.705 64.0744 27.2537 63.9973 26.8783H56.7988V26.8794ZM110.495 28.513C110.076 27.4053 108.796 25.3578 106.18 25.3578C103.583 25.3578 101.427 27.368 101.427 30.3168C101.427 33.0965 103.565 35.2757 106.429 35.2757C108.739 35.2757 110.076 33.8858 110.629 33.0778L108.911 31.9503C108.338 32.777 107.555 33.3215 106.429 33.3215C105.302 33.3215 104.501 32.8143 103.985 31.8185L110.725 29.0761L110.495 28.513ZM103.621 30.1663C103.564 28.2506 105.13 27.2735 106.256 27.2735C107.134 27.2735 107.878 27.7061 108.127 28.3253L103.621 30.1663ZM98.1425 34.9749H100.358V20.3989H98.1425V34.9749ZM94.5136 26.4655H94.4377C93.9411 25.8837 92.9871 25.3567 91.7842 25.3567C89.2634 25.3567 86.9535 27.5359 86.9535 30.3342C86.9535 33.1139 89.2634 35.2745 91.7842 35.2745C92.9871 35.2745 93.9411 34.7487 94.4377 34.147H94.5136V34.8606C94.5136 36.7576 93.4825 37.772 91.8209 37.772C90.4651 37.772 89.6249 36.8136 89.2812 36.0067L87.3529 36.7961C87.9064 38.1113 89.3772 39.7262 91.8209 39.7262C94.4176 39.7262 96.6136 38.2233 96.6136 34.5609V25.6575H94.5136V26.4655ZM91.975 33.3215C90.4473 33.3215 89.1686 32.0634 89.1686 30.3342C89.1686 28.5876 90.4473 27.3097 91.975 27.3097C93.4837 27.3097 94.6676 28.5876 94.6676 30.3342C94.6665 32.0634 93.4837 33.3215 91.975 33.3215ZM120.87 20.3989H115.571V34.9749H117.783V29.4528H120.871C123.322 29.4528 125.731 27.7073 125.731 24.9264C125.731 22.1455 123.321 20.3989 120.87 20.3989ZM120.927 27.424H117.781V22.4277H120.927C122.58 22.4277 123.519 23.7744 123.519 24.9264C123.519 26.0551 122.58 27.424 120.927 27.424ZM134.594 25.331C132.993 25.331 131.335 26.0248 130.649 27.5627L132.612 28.3696C133.032 27.5627 133.813 27.3004 134.633 27.3004C135.777 27.3004 136.939 27.9755 136.958 29.1753V29.3257C136.558 29.1006 135.7 28.7625 134.652 28.7625C132.536 28.7625 130.382 29.9063 130.382 32.0447C130.382 33.9954 132.117 35.2512 134.061 35.2512C135.548 35.2512 136.367 34.5947 136.881 33.8264H136.957V34.9515H139.092V29.363C139.092 26.7745 137.129 25.331 134.594 25.331ZM134.327 33.3192C133.603 33.3192 132.592 32.9624 132.592 32.0809C132.592 30.9557 133.851 30.5243 134.936 30.5243C135.908 30.5243 136.366 30.7307 136.957 31.0117C136.785 32.3631 135.604 33.3192 134.327 33.3192ZM146.868 25.6493L144.333 31.969H144.258L141.628 25.6493H139.246L143.191 34.4816L140.942 39.3951H143.248L149.329 25.6493H146.868ZM126.95 34.9749H129.161V20.3989H126.95V34.9749Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5824 8.78531C12.2375 9.14443 12.0337 9.70177 12.0337 10.4235V36.2104C12.0337 36.9333 12.2375 37.4895 12.5824 37.8486L12.6701 37.9325L27.3528 23.4872V23.3169V23.1467L12.6701 8.7002L12.5824 8.78531Z",
    fill: "url(#paint0_linear_208_8372)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2475 28.3037L27.354 23.487V23.3168V23.1466L32.2486 18.3311L32.3589 18.3929L38.1578 21.6343C39.8146 22.5601 39.8146 24.0747 38.1578 25.0016L32.3589 28.2431L32.2475 28.3037Z",
    fill: "url(#paint1_linear_208_8372)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.359 28.2415L27.3529 23.3164L12.5825 37.848C13.1289 38.417 14.0296 38.487 15.0452 37.9192L32.359 28.2415Z",
    fill: "url(#paint2_linear_208_8372)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3588 18.3919L15.0462 8.71424C14.0306 8.14641 13.1298 8.21754 12.5835 8.78537L27.3539 23.317L32.3588 18.3919Z",
    fill: "url(#paint3_linear_208_8372)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.2488 28.1333L15.0464 37.7492C14.0841 38.2867 13.2237 38.2517 12.6714 37.762L12.5825 37.8494L12.6702 37.9334C13.2225 38.4231 14.0829 38.4592 15.0452 37.9206L32.3578 28.2429L32.2488 28.1333Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M12.5824 37.6782C12.2375 37.3191 12.0337 36.7618 12.0337 36.04V36.2103C12.0337 36.932 12.2375 37.4894 12.5824 37.8485L12.6713 37.761L12.5824 37.6782Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M38.1577 24.8297L32.2485 28.1329L32.3588 28.2413L38.1577 24.9999C38.9861 24.537 39.3997 23.9272 39.3997 23.3174C39.3298 23.8689 38.9078 24.4099 38.1577 24.8297Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.0461 8.88407L38.1576 21.8032C38.909 22.2229 39.3297 22.7639 39.3996 23.3166C39.3996 22.7068 38.986 22.0958 38.1576 21.6329L15.0461 8.71384C13.3893 7.78805 12.0347 8.55643 12.0347 10.4232V10.5946C12.0347 8.72783 13.3893 7.95828 15.0461 8.88407Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_8372",
    x1: 26.0512,
    y1: 10.1515,
    x2: 6.48582,
    y2: 30.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_8372",
    x1: 40.314,
    y1: 23.3173,
    x2: 11.6372,
    y2: 23.3173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_208_8372",
    x1: 29.6391,
    y1: 25.9925,
    x2: 3.10684,
    y2: 52.9607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_208_8372",
    x1: 8.86369,
    y1: 0.20164,
    x2: 20.7115,
    y2: 12.2441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.7413382a6096b98640ce6985b0467302.svg";
export { ForwardRef as ReactComponent };